export default {
  0: {
    ar: "الكل",
    en: "All",
    id: 0,
    order: 0,
    fields: [],
    extendedDetails: [],
    search: {
      base: [],
      more: [],
      quickBase: [],
      quickMore: [],
    },
  },
  1: {
    en: "Apartment for rent",
    ar: "شقة للإيجار",
    id: 1,
    order: 1,
    fields: [
      "street_width",
      "area",
      "drainage_availability",
      "family",
      "rent_period",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "furnished",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "lift",
      "ac",
      "water_availability",
      "electrical_availability",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extendedDetails: [
      "separated_electrical_meter",
      "separated_water_meter",
      "fiber_optic",
      "special_parking",
      "ac_type",
      "roof_villa",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "master_bedroom",
      "master_bedroom_count",
      "bedrooms_count",
      "guestsrooms_count",
      "driversrooms_count",
      "other_rooms_count",
      "external_area",
      "internal_area",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["rent_period", "beds", "family", "price", "furnished"],
      more: [
        "livings",
        "wc",
        "car_entrance",
        "fl",
        "age",
        "ac",
        "private_roof",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
      quickBase: ["rent_period", "aptBeds", "family"],
      quickMore: [
        "car_entrance",
        "aptFl",
        "age",
        "ac",
        "private_roof",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
    },
  },
  2: {
    en: "Land for sale",
    ar: "أرض للبيع",
    id: 2,
    is_rent: false,
    order: 3,
    commercial: true,
    fields: [
      "street_direction",
      "type",
      "street_width",
      "area",
      "meter_price",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "fiber_optic",
      "raw_land",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["type", "price", "area", "street_width"],
      more: ["street_direction", "meter_price"],
      quickBase: ["type", "price", "area", "street_width"],
      quickMore: ["street_direction", "meter_price"],
    },
  },
  3: {
    en: "Villa for sale",
    ar: "فيلا للبيع",
    id: 3,
    order: 2,
    commercial: true,
    fields: [
      "street_direction",
      "beds",
      "apts",
      "livings",
      "wc",
      "street_width",
      "stairs",
      "age",
      "driver",
      "maid",
      "pool",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "basement",
      "lift",
      "duplex",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "fiber_optic",
      "ac_type",
      "accept_bank",
      "roof_villa",
      "laundry_room",
      "project_name",
      "upper_extension",
      "lower_extension",
      "balcony",
      "master_bedroom",
      "apartments_count",
      "floors_count",
      "master_bedroom_count",
      "bedrooms_count",
      "guestsrooms_count",
      "driversrooms_count",
      "other_rooms_count",
      "external_area",
      "internal_area",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["stairs", "apts", "price"],
      more: [
        "beds",
        "livings",
        "wc",
        "car_entrance",
        "driver",
        "maid",
        "pool",
        "furnished",
        "area",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
        "basement",
        "duplex",
      ],
      quickBase: ["stairs", "apts", "villaPrice"],
      quickMore: [
        "beds",
        "car_entrance",
        "driver",
        "maid",
        "pool",
        "furnished",
        "area",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
        "basement",
        "duplex",
      ],
    },
  },
  4: {
    id: 4,
    en: "Big flat for rent",
    ar: "دور للإيجار",
    is_rent: true,
    commercial: null,
    order: 5,
    fields: [
      "street_width",
      "street_direction",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "furnished",
      "car_entrance",
      "ac",
      "area",
      "water_availability",
      "electrical_availability",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extendedDetails: [
      "separated_electrical_meter",
      "separated_water_meter",
      "fiber_optic",
      "special_parking",
      "ac_type",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "master_bedroom",
      "apartments_count",
      "floors_count",
      "master_bedroom_count",
      "bedrooms_count",
      "guestsrooms_count",
      "driversrooms_count",
      "other_rooms_count",
      "external_area",
      "internal_area",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["beds", "livings", "wc", "fl", "area"],
      more: [
        "car_entrance",
        "age",
        "price",
        "ac",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
      quickBase: ["beds", "fl"],
      quickMore: [
        "car_entrance",
        "age",
        "ac",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
    },
  },
  5: {
    id: 5,
    en: "Villa for rent",
    ar: "فيلا للإيجار",
    order: 4,
    is_rent: true,
    commercial: null,
    fields: [
      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "stairs",
      "age",
      "driver",
      "maid",
      "pool",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "basement",
      "lift",
      "duplex",
      "ac",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "fiber_optic",
      "ac_type",
      "accept_bank",
      "roof_villa",
      "project_name",
      "upper_extension",
      "lower_extension",
      "balcony",
      "master_bedroom",
      "master_bedroom_count",
      "bedrooms_count",
      "guestsrooms_count",
      "driversrooms_count",
      "other_rooms_count",
      "external_area",
      "internal_area",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["stairs", "beds", "livings", "wc", "price"],
      more: [
        "car_entrance",
        "driver",
        "maid",
        "pool",
        "furnished",
        "area",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
        "duplex",
        "basement",
        "ac",
      ],
      quickBase: ["stairs", "beds", "price"],
      quickMore: [
        "car_entrance",
        "driver",
        "maid",
        "pool",
        "furnished",
        "area",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
        "duplex",
        "basement",
        "ac",
      ],
    },
  },
  6: {
    en: "Apartment for sale",
    ar: "شقة للبيع",
    id: 6,
    order: 6,
    is_rent: false,
    commercial: true,
    fields: [
      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "fl",
      "age",
      "furnished",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "lift",
      "area",
      "water_availability",
      "electrical_availability",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extendedDetails: [
      "fiber_optic",
      "special_parking",
      "ac_type",
      "accept_bank",
      "roof_villa",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "master_bedroom",
      "master_bedroom_count",
      "bedrooms_count",
      "guestsrooms_count",
      "driversrooms_count",
      "other_rooms_count",
      "external_area",
      "internal_area",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["beds", "livings", "wc", "price"],
      more: [
        "car_entrance",
        "fl",
        "age",
        "area",
        "private_roof",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
      quickBase: ["beds", "price"],
      quickMore: [
        "car_entrance",
        "fl",
        "age",
        "area",
        "private_roof",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
    },
  },
  7: {
    en: "Building for sale",
    ar: "عمارة للبيع",
    id: 7,
    order: 7,
    is_rent: false,
    commercial: true,
    fields: [
      "street_direction",
      "type",
      "street_width",
      "apts",
      "furnished",
      "age",
      "stores",
      "rooms",
      "basement",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["type", "price"],
      more: [
        "area",
        "apts",
        "stores",
        "street_width",
        "age",
        "street_direction",
      ],
      quickBase: ["type", "price"],
      quickMore: [
        "area",
        "apts",
        "stores",
        "street_width",
        "age",
        "street_direction",
      ],
    },
  },
  8: {
    en: "Store for rent",
    ar: "محل للإيجار",
    id: 8,
    order: 12,
    commercial: true,
    fields: [
      "street_direction",
      "street_width",
      "age",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["street_width", "area"],
      more: [],
      quickBase: ["street_width", "area"],
      quickMore: [],
    },
  },
  9: {
    en: "Small house for sale",
    ar: "بيت للبيع",
    id: 9,
    order: 8,
    fields: [
      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "age",
      "driver",
      "maid",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["beds", "livings", "area"],
      more: [
        "tent",
        "furnished",
        "age",
        "street_direction",
        "price",
        "street_width",
      ],
      quickBase: ["beds", "area"],
      quickMore: [
        "tent",
        "furnished",
        "age",
        "street_direction",
        "price",
        "street_width",
      ],
    },
  },
  10: {
    en: "Lounge for sale",
    ar: "استراحة للبيع",
    id: 10,
    order: 11,
    fields: [
      "street_direction",
      "livings",
      "wc",
      "street_width",
      "pool",
      "fb",
      "vb",
      "tent",
      "age",
      "playground",
      "beds",
      "family_section",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["price", "area"],
      more: ["street_width", "age"],
      quickBase: ["price", "area"],
      quickMore: ["street_width"],
    },
  },
  11: {
    en: "Small house for rent",
    ar: "بيت للإيجار",
    id: 11,
    order: 10,
    fields: [
      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "age",
      "driver",
      "maid",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["beds", "livings", "area"],
      more: [
        "tent",
        "furnished",
        "age",
        "street_direction",
        "ketchen",
        "price",
        "street_width",
      ],
      quickBase: ["beds", "area"],
      quickMore: [
        "tent",
        "furnished",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
      ],
    },
  },
  12: {
    en: "Farm for sale",
    ar: "مزرعة للبيع",
    id: 12,
    order: 13,

    fields: [
      "street_width",
      "tent",
      "wells",
      "trees",
      "area",
      "meter_price",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["area"],
      more: ["price", "meter_price"],
      quickBase: ["area"],
      quickMore: ["price", "meter_price"],
    },
  },
  13: {
    en: "Lounge for rent",
    ar: "استراحة للإيجار",
    id: 13,
    is_rent: true,
    order: 9,
    fields: [
      "street_width",
      "age",
      "rent_period",
      "livings",
      "beds",
      "wc",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
      "family_section",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["family_section", "rent_period", "price", "area"],
      more: ["pool", "fb", "vb", "tent", "ketchen", "playground"],
      quickBase: ["family_section", "rent_period", "area"],
      quickMore: ["pool", "fb", "vb", "tent", "ketchen", "playground"],
    },
  },
  14: {
    en: "Office for rent",
    ar: "مكتب للإيجار",
    id: 14,
    order: 17,
    commercial: true,
    fields: [
      "street_direction",
      "street_width",
      "age",
      "furnished",
      "area",
      "meter_price",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["furnished", "price", "meter_price", "street_width", "area"],
      more: [],
      quickBase: ["furnished", "meter_price", "street_width", "area"],
      quickMore: [],
    },
  },
  15: {
    en: "Land for rent",
    ar: "أرض للإيجار",
    id: 15,
    order: 15,
    commercial: true,
    fields: [
      "street_direction",
      "type",
      "street_width",
      "area",
      "meter_price",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "fiber_optic",
      "raw_land",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["meter_price", "type", "area"],
      more: ["street_direction", "street_width"],
      quickBase: ["meter_price", "type", "area"],
      quickMore: ["street_direction", "street_width"],
    },
  },
  16: {
    en: "Building for rent",
    ar: "عمارة للإيجار",
    id: 16,
    order: 14,
    commercial: true,
    fields: [
      "street_direction",
      "type",
      "street_width",
      "apts",
      "furnished",
      "age",
      "stores",
      "rooms",
      "basement",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["type", "area"],
      more: [
        "apts",
        "stores",
        "street_width",
        "age",
        "street_direction",
        "price",
      ],
      quickBase: ["type", "area"],
      quickMore: ["apts", "stores", "street_width", "age", "street_direction"],
    },
  },
  17: {
    en: "Warehouse for rent",
    ar: "مستودع للإيجار",
    id: 17,
    order: 19,
    fields: [
      "street_direction",
      "street_width",
      "age",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["price", "street_width", "area"],
      more: [],
      quickBase: ["street_width", "area"],
      quickMore: [],
    },
  },
  18: {
    en: "Tent for rent",
    ar: "مخيم للإيجار",
    id: 18,
    order: 18,
    fields: [
      "area",
      "rent_period",
      "family_section",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["rent_period", "family_section"],
      more: [],
      quickBase: ["rent_period", "family_section"],
      quickMore: [],
    },
  },
  19: {
    en: "Room for rent",
    ar: "غرفة للإيجار",
    id: 19,
    order: 16,
    fields: [
      "street_width",
      "area",
      "rent_period",
      "age",
      "furnished",
      "ketchen",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["rent_period", "ketchen", "price"],
      more: [],
      quickBase: ["rent_period", "ketchen"],
      quickMore: [],
    },
  },
  20: {
    en: "Store for sale",
    ar: "محل للتقبيل",
    id: 20,
    order: 20,
    fields: [
      "street_direction",
      "street_width",
      "age",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["price", "street_width", "area"],
      more: [],
      quickBase: ["price", "street_width", "area"],
      quickMore: [],
    },
  },
  21: {
    en: "Furnished apartment for rent",
    ar: "شقة مفروشة",
    id: 21,
    order: 21,
    fields: [
      "street_width",
      "area",
      "rent_period",
      "family",
      "beds",
      "livings",
      "fl",
      "age",
      "extra_unit",
      "car_entrance",
      "ac",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["price", "rent_period", "family", "livings"],
      more: ["fl", "age", "extra_unit", "car_entrance", "ac"],
      quickBase: [
        "price",
        "rent_period",
        "family",
        "livings",
        "fl",
        "age",
        "extra_unit",
        "car_entrance",
        "ac",
      ],
      quickMore: [],
    },
  },
  22: {
    en: "Floor for sale",
    ar: "دور للبيع",
    id: 22,
    order: 22,
    fields: [
      "area",
      "street_direction",
      "street_width",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "car_entrance",
      "water_availability",
      "electrical_availability",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extendedDetails: [
      "fiber_optic",
      "special_parking",
      "ac_type",
      "accept_bank",
      "laundry_room",
      "apartment_in_project",

      "project_name",
      "balcony",
      "master_bedroom",
      "apartments_count",
      "floors_count",
      "master_bedroom_count",
      "bedrooms_count",
      "guestsrooms_count",
      "driversrooms_count",
      "other_rooms_count",
      "external_area",
      "internal_area",
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["price", "area", "livings", "age"],
      more: ["fl", "car_entrance"],
      quickBase: ["price", "area", "livings", "fl", "age", "car_entrance"],
      quickMore: [],
    },
  },
  23: {
    en: "Chalet for rent",
    ar: "شاليه للإيجار",
    id: 13,
    order: 9,
    fields: [
      "street_width",
      "age",
      "rent_period",
      "livings",
      "beds",
      "wc",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
      "family_section",
      "area",
      "water_availability",
      "electrical_availability",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["family_section", "rent_period", "price", "area"],
      more: ["pool", "fb", "vb", "tent", "ketchen", "playground"],
      quickBase: ["family_section", "rent_period", "area"],
      quickMore: ["pool", "fb", "vb", "tent", "ketchen", "playground"],
    },
  },
  "daily-rent": {
    en: "Daily rent",
    ar: "الحجز اليومي",
    id: "daily-rent",
    order: 99,
    fields: [
      "beds",
      "livings",
      "wc",
      "furnished",
      "ketchen",
      "special_entrance",
    ],
    extendedDetails: [
      "is_constrained",
      "is_pawned",
      "national_address",
      "obligations",
      "guarantees_and_their_duration",
      "saudi_code_compliance",
      "channels",
    ],
    search: {
      base: ["price", "beds", "livings", "wc"],
      more: ["furnished", "ketchen", "special_entrance"],
      quickBase: ["beds", "livings", "wc"],
      quickMore: ["furnished", "ketchen", "special_entrance"],
    },
  },
};
